import { useState } from "react";
import { AnimatePresence, motion, useScroll, useMotionValueEvent } from "framer-motion";
import { useLocation } from "react-router-dom";
import { scrollToId } from "@/utils/scroll";
import { inr, PRODUCT } from "@/context/CartContext";

export default function StickyBuyBar() {
  const { scrollY } = useScroll();
  const [show, setShow] = useState(false);
  const { pathname } = useLocation();

  useMotionValueEvent(scrollY, "change", (v) => {
    setShow(v > window.innerHeight * 0.9);
  });

  if (pathname !== "/") return null;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="sticky-buy-bar"
          initial={{ y: 90 }}
          animate={{ y: 0 }}
          exit={{ y: 90 }}
          transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-0 inset-x-0 z-40 md:hidden bg-black/95 backdrop-blur border-t border-white/15 px-4 py-3 flex items-center justify-between gap-3"
        >
          <div>
            <p className="font-sans font-bold text-paper text-xs tracking-[0.15em]">{PRODUCT.name}</p>
            <p className="font-sans text-paper/60 text-xs mt-0.5">{inr(PRODUCT.price)}</p>
          </div>
          <button
            data-testid="sticky-buy-button"
            onClick={() => scrollToId("#product")}
            className="font-sans bg-pink text-black font-bold text-xs tracking-[0.15em] px-6 py-3.5"
          >
            BUY NOW →
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
